import { render, staticRenderFns } from "./BookHeader.vue?vue&type=template&id=9650bf6e&scoped=true&"
import script from "./BookHeader.vue?vue&type=script&lang=js&"
export * from "./BookHeader.vue?vue&type=script&lang=js&"
import style0 from "./BookHeader.vue?vue&type=style&index=0&id=9650bf6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9650bf6e",
  null
  
)

export default component.exports